export enum Actions {
  GET_HISTORIES_PENDING = 'GET_HISTORIES_PENDING',
  GET_HISTORIES_SUCCESS = 'GET_HISTORIES_SUCCESS',
  GET_HISTORIES_ERROR = 'GET_HISTORIES_ERROR',
}
